<template>
  <svg width="45" height="56" viewBox="0 0 45 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 22.4002H30V19.2002H14V22.4002ZM14 30.0002H30V26.8002H14V30.0002ZM24.4 37.6002H14V34.4002H24.4V37.6002Z" fill="#010101"/>
  </svg>
 </template>